<template>
    <section
        class="ResourceListing"
        :class="{ 'has-border lap-and-up-py-large desk-py-xlarge py-medium' : heading}"
    >
        <BaseHeading
            v-if="heading"
            :preheading="preheading"
            :heading="heading"
            tag="h2"
        />
        <div
            class="ResourceListing__bar"
        >
            <h6
                class="uppercase"
            >
                Resource
            </h6>
            <h6
                class="uppercase hide--portable"
            >
                Category
            </h6>
        </div>
        <ResourceItem
            v-for="item in itemsInView"
            :key="item.id"
            :resource="item"
        />
        <h2
            v-if="filteredItems.length < 1"
            class="my-medium"
        >No resources match your search.</h2>
        <div class="ResourceListing__button-wrap">
            <BaseButton
                v-if="paginateBy && filteredItems.length > (paginationIndex + paginateBy)"
                @click="paginationIndex += paginateBy"
            >
                Load More
            </BaseButton>
        </div>
    </section>
</template>

<script>
export default {
    name: "ResourceListing",
    props: {
        items: {
            type: Array,
            required: true
        },
        heading: {
            type: String,
            default: null
        },
        preheading: {
            type: String,
            default: null
        },
        activeSearchTerm: {
            type: String,
            default: null
        },
        paginateBy: {
            type: Number,
            default: 3
        },
    },
    data: () => ({
        paginationIndex: 0,
    }),
    computed: {
        filteredItems() {
            if (!this.activeSearchTerm) {
                return this.items;
            }
            return this.items.reduce((items, item) => {
                let matchesSearch = null;
                if(item.category) {
                    matchesSearch = matchesSearch || item.category.toLowerCase().includes(this.activeSearchTerm);
                }
                if(item.heading) {
                    matchesSearch = matchesSearch || item.heading.toLowerCase().includes(this.activeSearchTerm);
                }
                if(item.description) {
                    matchesSearch = matchesSearch || item.description.toLowerCase().includes(this.activeSearchTerm);
                }
                return matchesSearch ? items.concat([item]) : items;
            }, []);
        },
        itemsInView() {
            return this.filteredItems.slice(0, this.paginationIndex + this.paginateBy);
        }
    }
}
</script>

<style lang="scss" scoped>
    .ResourceListing__bar {
        display: none;

        @include media-query(lap-and-up) {
            display: flex;
            align-items: center;
            padding: 0.65rem 1rem;
            background: getColor('green');
        }

        h6 {
            color: getColor('white');
            width: calc(450px + 42px + 2.5rem);
            text-transform: uppercase;
            font-size: 0.7rem;

            &:last-child {
                width: auto;
            }

            @include media-query(desk-wide) {
                width: calc(600px + 42px + 2.5rem);
            }
        }
    }

    .ResourceListing__button-wrap {
        display: flex;
        justify-content: center;
        margin-top: getSpacing('medium');
        margin-bottom: getSpacing('xlarge');

        .BaseButton {
            cursor: pointer;
        }
    }

    .BaseHeading {
        text-align: center;
        margin-bottom: getSpacing('medium');

        @include media-query(desk) {
            margin-bottom: getSpacing('large');
        }
    }

    .has-border {
        border-top: 1px solid $border-color;
    }


</style>
